import "./ReportLoading.css";

function ReportLoading({ stage = "plan", message }) {
  const stages = {
    init: "Loading report...",
    building: "Building your report...",
    failed: "Report build failed.",
    complete: "Report build complete.",
    generic: "Loading...",
  };

  const displayMessage = message || stages[stage] || stages.generic;

  return (
    <div className="report-loading">
      <div className="report-loading-spinner"></div>
      <div className="report-loading-message">{displayMessage}</div>
    </div>
  );
}

export default ReportLoading;
